export enum ReferralStatuses {
  unassigned = 'unassigned',
  assigned = 'assigned',
  contacted = 'contacted',
  rejected = 'rejected',
  archived = 'archived',
  pending = 'pending',
}
